const SVG = ({ verticalClassName, horizontalClassName }) => (
	<svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path className={verticalClassName} d='M6 11H18V13H6V11Z' fill='#171717' />
		<path className={horizontalClassName} d='M13 6L13 18H11L11 6L13 6Z' fill='#171717' />
	</svg>
);

export default SVG;
